import withDisplayName from 'bz-utilities/hoc/display-name';

import type { PropsWithChildren } from 'react';
import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

export interface IProps<T extends FieldValues> extends PropsWithChildren {}

type GenericFC = <T extends FieldValues>(
  ...args: Parameters<React.FC<IProps<T>>>
) => ReturnType<React.FC>;

const HooksFormDebugger = React.memo(
  withDisplayName(<T extends FieldValues>({}: IProps<T>) => {
    const { formState } = useFormContext<T>();
    const { errors, isValid } = formState;

    React.useEffect(() => {
      console.log('[HooksFormDebugger.errors]', Object.entries(errors));
      if (Object.entries(errors).length == 0) {
        return;
      }
      console.log('[HooksFormDebugger.errors]', errors);
    }, [errors]);

    React.useEffect(() => {
      console.log('[HooksFormDebugger.isValid]', isValid);
    }, [isValid]);

    return null;
  }, 'HooksFormDebugger')
);

export default HooksFormDebugger as GenericFC;
